document.addEventListener("DOMContentLoaded", () => {
  const product_detail_images = document.getElementById(
    "product-detail-images"
  );
  product_detail_images.addEventListener(
    "vimeo-video",
    (/** @type CustomEvent */ e) => {
      if (!e.detail || !e.detail.element) return;
      const /** @type HTMLDivElement */ element = e.detail.element;
      const /** @type HTMLDivElement */ vimeo_wrapper = element.querySelector('.carousel-item-vimeo')
      console.log("vimeo-video", element.dataset);
      if(!vimeo_wrapper) return;
      vimeo_wrapper.insertAdjacentHTML(
        "afterbegin",
        `<iframe class="w-100 h-100" width="${element.dataset.vimeoEmbedWidth}" height="${element.dataset.vimeoEmbedHeight}" src="${element.dataset.vimeoEmbed}&autoplay=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe><script src="https://player.vimeo.com/api/player.js"></script>`
      );
    }
  );
  product_detail_images.addEventListener("stop-vimeo-video", () => {
    product_detail_images
      .querySelectorAll("iframe")
      .forEach(function (element) {
        element.remove();
      });
  });
});
